const Widget = () => {
  return <div>user profile</div>;
};

export default Widget;
